/*global Modernizr, lottie, tla_lottie_animations */
/*jslint browser:true */

(function() {
  'use strict';

  var lottie_blocks = document.querySelectorAll('.lottie');
  if(lottie_blocks) {
    lottie_blocks.forEach((lottie_block) => {
      setup_tla_lottie(lottie_block);
    });
  }
}());

function setup_tla_lottie(lottie_block) {
  'use strict';

  var lottieContainer = lottie_block.closest('.lottie-container');

  if(!lottieContainer) {
    lottieContainer = lottie_block.parentNode;
  }

  var animation = {
    container: lottie_block,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: tla_lottie_animations[lottie_block.getAttribute('data-json')]
  };

  if(lottie_block.classList.contains('auto-play')) {
    animation.loop = true;
    animation.autoplay = true;
  }

  var lottie_animation = lottie.loadAnimation(animation);

  lottie_block.lottie_animation = lottie_animation;

  lottie_block.addEventListener('lottie-updated', (e) => {
    e.target.lottie_animation.destroy();

    var lottie_animation = lottie.loadAnimation({
      container: e.target,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: tla_lottie_animations[e.target.getAttribute('data-json')]
    });

    e.target.lottie_animation = lottie_animation;
  });

  if(lottie_block.classList.contains('auto-play')) {
    return;
  }

  lottieContainer.addEventListener('mouseenter', () => {
    lottie_block.lottie_animation.setDirection(1);
    lottie_block.lottie_animation.play();
  });

  lottieContainer.addEventListener('mouseleave', () => {
    lottie_block.lottie_animation.setDirection(-1);
    lottie_block.lottie_animation.play();
  });
}